<template>
  <footer class="footer-modern">
    <v-container>
      <v-row class="pb-8">
        <!-- Logo and Description -->
        <v-col cols="12" md="4" class="mb-8 mb-md-0">
          <div class="footer-logo mb-4">
            <div class="footer-logo-icon">
              <v-icon color="#0A0E14" size="24">mdi-dumbbell</v-icon>
            </div>
            <div class="footer-logo-text">
              <div class="logo-name-footer">GymDesk</div>
              <div class="logo-suite-footer">SUITE</div>
            </div>
          </div>
          <p class="footer-description">
            Empowering fitness centers with innovative technology that streamlines operations and enhances member experience.
          </p>
        </v-col>

        <!-- Company -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Company</h4>
          <ul class="footer-links">
            <li><router-link to="/why">Why GymDesk Suite</router-link></li>
            <li><router-link to="/features">Features</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/blog">Blog</router-link></li>
            <li><router-link to="/tribzz">Tribzz for Gyms</router-link></li>
          </ul>
        </v-col>

        <!-- Support -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Support</h4>
          <ul class="footer-links">
            <li><router-link to="/documentation">Documentation</router-link></li>
            <li><router-link to="/help">Help Center</router-link></li>
            <li><router-link to="/contact">Contact Us</router-link></li>
            <li><a href="#" @click.prevent="requestDemo">Request Demo</a></li>
            <li><router-link to="/login">Client Portal</router-link></li>
          </ul>
        </v-col>

        <!-- Legal -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Legal</h4>
          <ul class="footer-links">
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Service</router-link></li>
            <li><router-link to="/cookies">Cookie Policy</router-link></li>
            <li><router-link to="/security">Security</router-link></li>
          </ul>
        </v-col>

        <!-- Contact -->
        <v-col cols="12" sm="6" md="2">
          <h4 class="footer-heading mb-4">Contact</h4>
          <div class="footer-contact">
            <div class="contact-item mb-2">
              <v-icon small color="#FF7A45" class="mr-2">mdi-email</v-icon>
              <a href="mailto:ricosevere@codeforgedev.com">ricosevere@codeforgedev.com</a>
            </div>
            <div class="contact-item mb-2">
              <v-icon small color="#FF7A45" class="mr-2">mdi-phone</v-icon>
              <a href="tel:3392418725">(339) 241-8725</a>
            </div>
            <div class="contact-item">
              <v-icon small color="#FF7A45" class="mr-2">mdi-map-marker</v-icon>
              <span>United States</span>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-6" style="border-color: rgba(226,232,240,0.09) !important;"></v-divider>

      <div class="footer-bottom">
        <p class="copyright mb-0">
          © {{ currentYear }} GymDesk Suite. All rights reserved.
        </p>
        <div class="footer-meta">
          <span class="meta-item">Made in USA</span>
          <span class="meta-divider">•</span>
          <span class="meta-item">Enterprise Grade</span>
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    // Request Demo opens the demo page.
    requestDemo() {
      this.$router.push('/demo').catch(() => {});
    }
  }
};
</script>

<style scoped>

.footer-modern {
  --ember: #FF7A45;
  --ember-light: #FFB07A;
  --ember-dark: #D9501E;
  --text-primary: #F1F3F6;
  --text-secondary: rgba(241, 243, 246, 0.7);
  --text-muted: rgba(241, 243, 246, 0.5);
  --border-subtle: rgba(226, 232, 240, 0.09);

  background: #07090D;
  border-top: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  padding: 64px 0 24px;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-logo-icon {
  width: 44px;
  height: 44px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(140deg, var(--ember-light) 0%, var(--ember) 55%, var(--ember-dark) 100%);
}

.footer-logo-text {
  display: flex;
  flex-direction: column;
}

.logo-name-footer {
  font-family: 'Fraunces', Georgia, serif;
  font-size: 1.45rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1;
  letter-spacing: -0.01em;
}

.logo-suite-footer {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 3px;
  color: var(--ember);
  margin-top: 4px;
}

.footer-description {
  font-size: 0.95rem;
  line-height: 1.7;
  color: var(--text-muted);
  max-width: 320px;
}

.footer-heading {
  font-size: 0.98rem;
  font-weight: 600;
  color: var(--text-primary);
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.93rem;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: var(--ember-light);
  transform: translateX(4px);
}

.footer-contact {
  font-size: 0.93rem;
}

.contact-item {
  display: flex;
  align-items: center;
}

.contact-item a {
  color: var(--text-secondary);
  text-decoration: none;
  word-break: break-all;
}

.contact-item a:hover {
  color: var(--ember-light);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.copyright,
.footer-meta {
  font-size: 0.87rem;
  color: var(--text-muted);
}

.footer-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.meta-item {
  font-weight: 600;
}

.meta-divider {
  opacity: 0.5;
}

@media (max-width: 600px) {
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>